<template>
  <div>
    <v-tabs :show-arrows="true" color="#62c6c5" dark slider-color="black" v-model="active">
      <v-tab :key="index" ripple v-for="(item, index) in options">{{ item }}</v-tab>
      <v-tab-item :key="n + 100" v-for="n in options.length">
        <v-expansion-panel>
          <v-expansion-panel-content>
            <div slot="header" v-if="exceptionTabs !== n">{{dialogs[0]}}</div>
            <div slot="header" v-else>{{exceptionDialog[0]}}</div>
            <v-card flat>
              <chronometer
                :minutes-init="timesController[n-1].minutes"
                :seconds-init="timesController[n-1].seconds"
              />
            </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content>
            <div slot="header" v-if="exceptionTabs !== n">{{dialogs[1]}}</div>
            <div slot="header" v-else>{{exceptionDialog[1]}}</div>
            <v-card flat>
              <chronometer
                :minutes-init="timesController[n-1].minutes"
                :seconds-init="timesController[n-1].seconds"
              />
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import chronometer from './v-card-chronometer'

export default {
  name: 'tabulation',
  components: {
    chronometer
  },
  props: {
    menu: {
      type: Array,
      default: () => [],
      required: false
    },
    exceptionTabs: {
      type: Number,
      default: 7,
      required: false
    }
  },
  data () {
    return {
      options: [],
      active: null,

      timesController: [
        {
          minutes: 4,
          seconds: 0
        },
        {
          minutes: 4,
          seconds: 0
        },
        {
          minutes: 1,
          seconds: 0
        },
        {
          minutes: 1,
          seconds: 0
        },
        {
          minutes: 1,
          seconds: 0
        },
        {
          minutes: 1,
          seconds: 0
        },
        {
          minutes: 3,
          seconds: 0
        }
      ]
    }
  },
  mounted () {
    if (this.menu.length) { this.options = this.menu } else { this.options = this.menuBase }
    this.options.forEach(item => item.trim().toUpperCase())
  },
  computed: {
    menuBase () {
      return [this.$t('categoryAspectBase1'), this.$t('categoryAspectBase2'), this.$t('categoryAspectBase3'), this.$t('categoryAspectBase4'), this.$t('categoryAspectBase5'), this.$t('categoryAspectBase6'), this.$t('categoryAspectBase7')]
    },
    dialogs () {
      return [this.$t('homeTeam'), this.$t('visitorTeam')]
    },
    exceptionDialog () {
      return [this.$t('visitorTeam'), this.$t('homeTeam')]
    }
  }
}
</script>
